export function getCleanListingUrl(url?: string): string | undefined {
  if (!url || url === '#') {
    return undefined;
  }

  return url;
}

export function appendAffiliateCodeToListingUrl(url: string, affiliateCode: string): string {
  const parsedUrl = new URL(url);
  parsedUrl.searchParams.set('aff', affiliateCode);
  return parsedUrl.toString();
}

export function getListingActivationUrl(url?: string, affiliateCode?: string): string | undefined {
  const cleanUrl = getCleanListingUrl(url);

  if (!cleanUrl) {
    return undefined;
  }

  if (!affiliateCode) {
    return cleanUrl;
  }

  return appendAffiliateCodeToListingUrl(cleanUrl, affiliateCode);
}
